<script>
    import { createEventDispatcher } from 'svelte';
    import Card from '../shared/Card.svelte';
    import Button from '../shared/Button.svelte';
    import PollStore from '../stores/PollStore.js';
    import { tweened } from 'svelte/motion';
    import { cubicOut } from 'svelte/easing';
export let poll;

//reactive values
$: totalVotes = poll.votesA + poll.votesB;

// reactive percentages (0-100)
$: percentA = totalVotes ? (poll.votesA / totalVotes) * 100 : 0;
$: percentB = totalVotes ? (poll.votesB / totalVotes) * 100 : 0;

// tweened stores for smooth animated widths
const tweenedA = tweened(0, { duration: 420, easing: cubicOut });
const tweenedB = tweened(0, { duration: 420, easing: cubicOut });

$: tweenedA.set(percentA);
$: tweenedB.set(percentB);

const handleVote = (answer, pollId) => {
    if (answer === 'a') {
        poll.votesA += 1;
    } else if (answer === 'b') {
        poll.votesB += 1;
    }
};

const deletePoll = () => {
    console.log('deleting poll', poll.id);
    PollStore.update(list => list.filter(p => p.id !== poll.id));
};
</script>
<Card>
<div class="poll">
<h3>{poll.question}</h3>

    <div class="answer" on:click={() => handleVote('a', poll.id)} on:keydown={() => handleVote('a', poll.id)} role="button" tabindex="0" aria-pressed="false">
        <div class="percent percent-a" style="width: {$tweenedA}%" aria-hidden="true"></div>
        <span>{poll.answerA} - {poll.votesA}</span>
    </div>
    <div class="answer" on:click={() => handleVote('b', poll.id)} on:keydown={() => handleVote('b', poll.id)} role="button" tabindex="0" aria-pressed="false">
        <div class="percent percent-b" style="width: {$tweenedB}%" aria-hidden="true"></div>
        <span>{poll.answerB} - {poll.votesB}</span>
    </div>
    <p>Total Votes: {totalVotes}</p>
    <div class="actions">
        <Button type="button" variant="secondary" on:click={deletePoll}>Delete</Button>
    </div>
</div>
</Card>
<style>
h3 {
    margin: 0 auto;
    color: #555;
}
p {
    margin-top: 6px;
    font: 0.9rem;
    color: #aaa;
    margin-bottom: 30px;
}
.answer {
    margin: 10px 0;
    position: relative;
    background-color: #fafafa;
    border-radius: 6px;
    overflow: hidden;
    height: 35px;
    cursor: pointer;
    align-items: center;
    padding: 0 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.answer:hover {
    opacity: 0.7;
}
.percent {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 0%;
    z-index: 0;
    transition: width 420ms cubic-bezier(.2,.8,.2,1);
}
.percent-a {
    border-left: 4px solid #b01534;
    background: linear-gradient(90deg, #d91b42, #ff6b88);
}
.percent-b {
    border-left: 4px solid #2a9d82;
    background: linear-gradient(90deg, #45c496, #74e2b7);
}

span {
    display: inline-block;
    padding: 10px 20px;
    position: relative;
    z-index: 1;
}
.actions {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
}
</style>